const ARABIC_SHORT_LABELS = {
  الأحد: "ح",
  الاثنين: "ن",
  الثلاثاء: "ث",
  الأربعاء: "ر",
  الخميس: "خ",
  الجمعة: "ج",
  السبت: "س"
};
function hasSharedShortPrefix(short) {
  return short.startsWith("ال") || short.startsWith("יום ");
}
function formatWeekDayLabel(weekDay) {
  const { short, narrow } = weekDay;
  if (narrow && (/^T\d$/.test(narrow) || narrow === "CN")) {
    return narrow;
  }
  const vietnameseMatch = short.match(/^Th\s*(\d)$/);
  if (vietnameseMatch) {
    return `T${vietnameseMatch[1]}`;
  }
  if (short === "CN") {
    return "CN";
  }
  if (hasSharedShortPrefix(short)) {
    if (narrow) return narrow;
    const arabicLabel = ARABIC_SHORT_LABELS[short];
    if (arabicLabel) return arabicLabel;
    const hebrewMatch = short.match(/^יום\s+(.+)$/);
    if (hebrewMatch?.[1]) return hebrewMatch[1];
  }
  return short.slice(0, 2);
}
export {
  formatWeekDayLabel
};
//# sourceMappingURL=formatWeekDayLabel.js.map
